import React from 'react'
import { toAbsoluteUrl } from '@/utils';

const DefaultInvoiceTemplate = ({ data, companyData }) => {
    // const { account_owner, firm_email, phone_number, website, address, state, country, company_logo } = companyData
    return (
        <>
            <div id={`invoice-template-${data?.invoice_template?.name}`} class="bg-[--tw-navbar-bg] dark:bg-[--tw-navbar-bg-dark] border border-gray-300 dark:border-t-light dark:border-light p-6 rounded-lg shadow-lg relative">
                <div>
                    {companyData && companyData.company_logo ? (
                        <img src={companyData.company_logo} className="h-[80px] rounded-full" alt="logo" />
                    ) : (
                        <>
                            <img src={toAbsoluteUrl('/media/app/oak-legal-black.svg')} className="dark:hidden h-[15px]" alt="logo" />
                            <img src={toAbsoluteUrl('/media/app/oak-legal-white.svg')} className="hidden dark:inline-block h-[15px]" alt="logo" />
                        </>
                    )}
                </div>
                <div class="flex items-center justify-between my-8">
                    <div class="flex items-center">
                        {/* Company Info */}
                        <div>
                            <h4 className='font-normal text-xl text-gray-600'>{companyData && companyData.account_owner}</h4>
                            <div className='text-xs space-y-1 mt-2'>
                                <p>{companyData && companyData.address}</p>
                                <div>{companyData && companyData.country}, {companyData && companyData.city}</div>

                                <div>
                                    Email:
                                    <a className='link ml-2' href={`mailto:${companyData && companyData.firm_email}`}>{companyData && companyData.firm_email}</a>
                                </div>
                                <div>
                                    Website:
                                    <a className='link ml-2' href={companyData && companyData.website} target='_blank'>{companyData && companyData.website}</a>
                                </div>
                                <div>
                                    Phone:
                                    <a className='link ml-2' href={`tel:${companyData && companyData.phone_number}`}>{companyData && companyData.phone_number}</a>
                                </div>
                                {/* <a href={`mailto:${email}`}></a> */}
                                {/* <a href={`mailto:${website}`}></a> */}
                            </div>
                        </div>
                    </div>
                    {/* Invoice Info */}
                    <div class="text-gray-700">
                        <div class="font-medium text-xl text-gray-700 mb-1">INVOICE</div>
                        <div className='text-xs space-y-1 mt-2'>
                            <div class="">Issue Date:  {data && data.date}</div>
                            <div class="text-xs">Due Date: {data && data.due_date ? (data.due_date) : ('N/A')}</div>
                            <div class="text-xs">Invoice #: {data && data.number}</div>
                        </div>
                    </div>
                </div>
                {/* Contact Info */}
                <div class="pb-8 mb-8">
                    <h2 class="font-medium text-xl text-gray-700 mb-1">Bill To:</h2>
                    <div className='text-xs space-y-1 mt-2'>
                        <div>{data && data.contact.first_name + ' ' + data.contact.middle_name + ' ' + data.contact.last_name}</div>
                        {/* <div>{data && data.contact.address.address}</div>
                <div>{data && data.contact.address.country}, {data && data.contact.address.city}</div> */}
                        <div>
                            Email:
                            <a className='link ml-2' href={`mailto:${data && data.contact.email}`}>{data && data.contact.email}</a>
                        </div>
                        <div>
                            Website:
                            <a className='link ml-2' href={data && data.contact.website} target='_blank'>{data && data.contact.website}</a>
                        </div>
                        <div>
                            {
                                data && data.contact.home_number && (
                                    <>
                                        Home Number:
                                        <a className='link ml-2' href={`tel:${data && data.contact.home_number}`}>{data && data.contact.home_number}</a>
                                    </>
                                )

                            }
                        </div>
                    </div>
                </div>
                {/* <table class="w-full text-left mb-8">
            <thead>
                <tr className='bg-gray-100 '>
                    <th class="text-gray-700 font-medium text-sm uppercase p-1.5 rounded-l-md">Item</th>
                    <th class="text-gray-700 font-medium text-sm uppercase p-1.5">Billed By</th>
                    <th class="text-gray-700 font-medium text-sm uppercase p-1.5">Rate</th>
                    <th class="text-gray-700 font-medium text-sm uppercase p-1.5">Hours</th>
                    <th class="text-gray-700 font-medium text-sm uppercase p-1.5 rounded-r-md">Sub</th>
                </tr>
            </thead>
            <tbody>
                <tr className='border-b'>
                    <td class="py-2.5 px-1 text-xs text-gray-700">Product 1</td>
                    <td class="py-2.5 px-1 text-xs text-gray-700">User</td>
                    <td class="py-2.5 px-1 text-xs text-gray-700">$100.00</td>
                    <td class="py-2.5 px-1 text-xs text-gray-700">1</td>
                    <td class="py-2.5 px-1 text-xs text-gray-700">$100.00</td>
                </tr>
                <tr className='border-b'>
                    <td class="py-2.5 px-1 text-xs text-gray-700">Product 1</td>
                    <td class="py-2.5 px-1 text-xs text-gray-700">User</td>
                    <td class="py-2.5 px-1 text-xs text-gray-700">$100.00</td>
                    <td class="py-2.5 px-1 text-xs text-gray-700">1</td>
                    <td class="py-2.5 px-1 text-xs text-gray-700">$100.00</td>
                </tr>
            </tbody>
            <tfoot>
                <tr>
                    <td class="py-2.5 px-1 text-xs text-gray-700" colSpan="4">Total</td>
                    <td class="py-2.5 px-1 text-xs text-gray-700">$425.00</td>
                </tr>
            </tfoot>
        </table> */}
            </div>
        </>
    )
}

export { DefaultInvoiceTemplate }